import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { BrandDetailsInfo } from '@models/brands.model';
import { DeleteCompanyModalComponent } from '@web-components/settings/companies-section/delete-company-modal/delete-company.modal';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import {
	ActionMethodEnum,
	CustomizedLabels,
	GeneralAction,
	PropsAction
} from '@models/models';
import { takeUntil } from 'rxjs/operators';
import { AlertModalComponent } from '@web-components/common/alert-modal/alert-modal.component';
import { SettingsProvider } from '@services/settings/settings';

@Component({
	selector: 'company-list-item',
	template: require('./company-list-item.component.html'),
	styles: [require('./company-list-item.component.scss')]
})
export class CompanyListItemComponent implements OnInit, OnDestroy {
	@Input() company: BrandDetailsInfo;
	@Output() onCompanyDelete: EventEmitter<void> = new EventEmitter();

	private deleteCompanySubscription: Subscription;
	private deleteModalRef: NgbModalRef;
	private alertModalRef: NgbModalRef;

	private businessNumberLabelName: string;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private modalService: SNModalService,
		private brandsDataService: BrandsDataServiceProvider,
		private settingsService: SettingsProvider
	) {}

	ngOnInit(): void {
		this.subscribeToCustomizeLabelsChange();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	openDeleteCompanyModal() {
		if (
			this.company.actions.DELETE_BRAND.method ===
			ActionMethodEnum.ALERT_MODAL.toString()
		) {
			this.showAlert(this.company.actions.DELETE_BRAND as GeneralAction);
		} else {
			this.deleteModalRef = this.modalService.openModal(
				DeleteCompanyModalComponent,
				{
					windowClass: 'ng-bootstrap-modal__small'
				}
			);

			this.subscribeToDeleteCompanyData();
			this.deleteModalRef.componentInstance.btnDisabled = false;
			this.deleteModalRef.componentInstance.company = this.company;
			this.deleteModalRef.result.then(data =>
				this.deleteCompanySubscription.unsubscribe()
			);
		}
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.businessNumberLabelName = customizeLabels.businessNumberLabel)
			);
	}

	private subscribeToDeleteCompanyData(): void {
		this.deleteCompanySubscription = this.modalService
			.getModalData()
			.filter(
				(data: PropsAction<BrandDetailsInfo>): boolean =>
					data.action === 'DELETE_COMPANY'
			)
			.subscribe((data: PropsAction<BrandDetailsInfo>): void => {
				this.brandsDataService
					.deleteBrand(data.props.actions.DELETE_BRAND.url)
					.pipe(takeUntil(this.unsubscribe))
					.subscribe(() => {
						this.deleteModalRef.componentInstance.btnDisabled = false;
						this.deleteModalRef.close();
						this.onCompanyDelete.emit();
					});
			});
	}

	private showAlert(action: GeneralAction): void {
		this.alertModalRef = this.modalService.openModal(AlertModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});
		this.alertModalRef.componentInstance.title = action.alertMessage.title;
		this.alertModalRef.componentInstance.message = action.alertMessage.message;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/companies-section/company-list-item/company-list-item.component.ts